

	import { Component, Prop } from 'vue-property-decorator';
	import { PropType } from 'vue';
	import { Pro } from '@shared/models';
	import { BaseView } from '@shared/views/BaseView';
	import CompanyItemList from '../companies/CompanyItemList.vue';
	import AccountList from '../../common/AccountList.vue';

	@Component({
		components: {
			CompanyItemList,
			AccountList,
		},
	})
	export default class ProGeneralInfo extends BaseView {

		@Prop({ type: Object as PropType<Pro> })
		public model: Pro;

	}

